import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import { formatViews } from '@/lib/format';

interface MovieCardProps {
  item: ContentItem;
  showViews?: boolean;
}

export default function MovieCard({ item, showViews = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 封面海报`}
          title={`${item.title} - 91大神影视大全`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-900/80 text-background-50 text-[11px] font-medium">
          {item.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[11px] font-semibold font-label">
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-primary-950/90 to-transparent">
          <div className="flex items-center gap-1 text-[11px] text-background-100/90">
            <i className="ri-play-circle-line text-sm" />
            <span>{item.episodes > 1 ? `全${item.episodes}集` : item.duration}</span>
          </div>
        </div>
      </div>
      <div className="p-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
          <span>{item.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400" />
          <span className="truncate">{item.region}</span>
          {showViews && (
            <>
              <span className="w-0.5 h-0.5 rounded-full bg-foreground-400" />
              <span className="flex items-center gap-0.5">
                <i className="ri-fire-line text-accent-500" />
                {formatViews(item.views)}
              </span>
            </>
          )}
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[10px]"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}